import { render, staticRenderFns } from "./CotStatiEditComponent.vue?vue&type=template&id=4f132a76"
import script from "./CotStatiEditComponent.vue?vue&type=script&lang=js"
export * from "./CotStatiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports